import React, { Component } from 'react';
import Cabecera from "./cabecera";
import Footer from "./footer2";
import Body from "./bodyAviso";

class Av extends Component {
  render() {
    return (
        <div className="container">
        <Cabecera />
        <Body />
        <Footer />
        </div>
    );
  }
}

export default Av;


// WEBPACK FOOTER //
// ./src/components/aviso.js